import React from "react";

interface VideoPlayerProps {
    videoUrl: string;
    videoCaptionUrl?: string;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({
    videoUrl,
    videoCaptionUrl,
}) => {
    const videoRef = React.useRef<HTMLVideoElement>(null);

    React.useEffect(() => {
        if (videoRef.current) {
            videoRef.current.focus();
        }
    }, []);

    return (
        <video
            ref={videoRef}
            controls 
            controlsList="nodownload" 
            autoPlay
            tabIndex={0}
            >
            <source src={videoUrl} type="video/mp4" />
            <track kind="captions" src={videoCaptionUrl} />
        </video>
    );
};

export default VideoPlayer;